"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),i=require("react/jsx-runtime"),a=require("@vds-tokens/core"),t=require("@vds/typography"),n=require("@vds/icons"),o=require("styled-components"),r=require("@vds/buttons"),s=require("@plans/utilities"),l=require("../tile/index.js");function d(e){return e&&e.__esModule?e:{default:e}}var c=d(o);const u=c.default.div.withConfig({displayName:"HeaderWrapper",componentId:"VDS__sc-jg30km-0"})`
  display: flex;
  flex-direction: column;
  padding-bottom: 2px;
  padding-left: ${({variant:e})=>"image"===e?0:a.LayoutTokens.space["2X"].value};
`,m=c.default.div.withConfig({displayName:"InnerWrapper",componentId:"VDS__sc-jg30km-1"})`
  display: flex;
  flex-direction: ${({variant:e})=>"image"===e?"column":"row"};
  justify-content: ${({variant:e})=>"image"===e?"space-between":"unset"};
  width: 100%;
`,p=c.default.div.withConfig({displayName:"TitleWrapper",componentId:"VDS__sc-jg30km-2"})`
  padding-bottom: ${({variant:e})=>"image"===e&&a.LayoutTokens.space["1X"].value};
  width: ${({width:e})=>e||"100%"};
`,g=c.default.div.withConfig({displayName:"SubtitleWrapper",componentId:"VDS__sc-jg30km-3"})`
  ${({hasTitle:e})=>e&&o.css`
      > * {
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        overflow: hidden;
      }
    `};
`,v=c.default.div.withConfig({displayName:"ButtonWrapper",componentId:"VDS__sc-jg30km-4"})`
  display: flex;
  margin-top: auto;
  padding-top: ${a.LayoutTokens.space["4X"].value};
  @media (min-width: ${s.breakpoints.tabletSmall.min}) {
    padding-top: ${a.LayoutTokens.space["6X"].value};
  }
`,b=c.default.div.withConfig({displayName:"IconWrapper",componentId:"VDS__sc-jg30km-5"})`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`,k=c.default(l.default).withConfig({displayName:"StyledTile",componentId:"VDS__sc-jg30km-6"})`
  ${({variant:e})=>"image"===e&&o.css`
      @media (max-width: ${s.breakpoints.mobileLarge.max}) {
        > div {
          aspect-ratio: 16/9 !important;
          > div {
            height: 100%;
          }
        }
      }
    `}
  width: 100%;
`;exports.default=o=>{const{variant:s,backgroundImage:l,backgroundColor:d="dark",background:c,title:h,subtitle:j,textLink:x,button:y,icon:f={name:"tag"}}=o,w=e.__rest(o,["variant","backgroundImage","backgroundColor","background","title","subtitle","textLink","button","icon"]),_="light"===d?a.ColorTokens.elements.primary.onlight.value:a.ColorTokens.elements.primary.ondark.value,C="light"===d?a.ColorTokens.elements.primary.onlight.value:a.ColorTokens.elements.primary.ondark.value,T="icon"===s?t.Body:t.Title;return i.jsx(k,Object.assign({padding:"16px",width:"image"===s?void 0:"100%",height:"auto",backgroundImage:l,background:c,borderRadius:"16px",backgroundColor:a.ColorTokens.background.secondary[`${d||"dark"}`].value},w,{variant:s},{children:i.jsxs(m,Object.assign({variant:s},{children:["icon"===s&&i.jsx(b,{children:i.jsx(n.Icon,Object.assign({size:"medium",color:a.ColorTokens.elements.primary[`on${d||"dark"}`].value},f))}),i.jsxs(u,Object.assign({variant:s},{children:[i.jsx(p,Object.assign({width:h&&h.width,variant:s},{children:i.jsxs(T,Object.assign({color:_,size:"icon"===s?"medium":"small",bold:"image"===s,primitive:"span"},h,{children:[null==h?void 0:h.children,"icon"===s&&x&&i.jsx(r.TextLink,Object.assign({surface:d},x,{type:"inline",size:"small"}))]}))})),"image"===s&&j&&i.jsx(g,Object.assign({hasTitle:!!h},{children:i.jsx(t.Body,Object.assign({size:"small",primitive:"span",color:C},j,{children:null==j?void 0:j.children}))}))]})),"image"===s&&y&&i.jsx(v,{children:i.jsx(r.Button,Object.assign({use:"secondary",surface:d,size:"small",width:"auto"},y))})]}))}))};
